import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SectionHeader, Button, Loading } from "@/components/brand";
import { CURRENCY_META } from "@/lib/i18n";
import dayjs from "dayjs";

export default function AdminRates() {
  const qc = useQueryClient();
  const rates = useQuery({ queryKey: ["rates"], queryFn: () => api("/rates") });
  const [overrides, setOverrides] = useState({});
  useEffect(() => { if (rates.data) setOverrides({ ...(rates.data.overrides || {}) }); }, [rates.data]);

  const save = useMutation({
    mutationFn: () => {
      const body = {};
      CURRENCY_META.filter((c) => c.key !== "ZAR").forEach((c) => { body[c.key] = overrides[c.key] ? Number(overrides[c.key]) : null; });
      return api("/admin/rates", { method: "PUT", body: { overrides: body } });
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["rates"] }); toast.success("Rates saved"); },
    onError: (e) => toast.error(e.message),
  });

  if (rates.isLoading) return <Loading />;
  const d = rates.data;

  return (
    <div data-testid="admin-rates-screen" className="space-y-5 max-w-2xl">
      <SectionHeader title="Exchange Rates" subtitle={`Base ZAR · source ${d.source} · updated ${d.updated_at ? dayjs(d.updated_at).format("D MMM YYYY") : "–"}`} />
      <p className="font-body text-sm text-mutedgrey">Live rates refresh daily. Set an override to pin a specific ZAR→currency rate, or leave blank to use the live rate.</p>
      <div className="space-y-2">
        {CURRENCY_META.filter((c) => c.key !== "ZAR").map((c) => (
          <div key={c.key} data-testid={`rate-row-${c.key}`} className="flex items-center gap-3 p-3 rounded-xl2 border border-divider">
            <div className="w-9 text-center font-display text-brand text-lg">{c.symbol}</div>
            <div className="flex-1"><div className="font-body font-semibold text-sm text-ink">{c.key} · {c.name}</div><div className="font-body text-xs text-mutedgrey">Live: {Number(d.live?.[c.key] ?? 0).toFixed(4)}</div></div>
            <input data-testid={`rate-input-${c.key}`} type="number" step="0.0001" placeholder="live" value={overrides[c.key] ?? ""} onChange={(e) => setOverrides((o) => ({ ...o, [c.key]: e.target.value }))} className="w-32 h-11 px-3 rounded-md border border-line bg-surface2 font-body text-sm text-center" />
          </div>
        ))}
      </div>
      <Button testID="save-rates" title="Save Overrides" loading={save.isPending} onClick={() => save.mutate()} />
    </div>
  );
}
